import { Component, OnInit } from '@angular/core';
import { HeaderBreadcrumbService } from '../../header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';

@Component({
  selector: 'app-catalogs-new-preparation-dashboard',
  templateUrl: './catalogs-new-preparation-dashboard.component.html',
  styleUrls: ['./catalogs-new-preparation-dashboard.component.scss']
})
export class CatalogsNewPreparationDashboardComponent implements OnInit {

  constructor(private headerBreadcrumbService: HeaderBreadcrumbService) { }

  ngOnInit() {
    this.setBreadcrumb();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-cut', 'catalogs-page.new preparation', '/catalog/preparations', [new BRoute('catalogs-page.catalog', '/catalog'), new BRoute('catalogs-page.preparations', '/catalog/preparations'), new BRoute('catalogs-page.new preparation')]));
  }
}
